import { useOnboardingStatus } from './useOnboardingStatus';

/**
 * Returns the module_visibility map from onboarding status.
 * An empty object means "show all" — null/missing preserves backwards compat
 * for existing tenants who have never completed onboarding.
 */
export function useModuleVisibility(): Record<string, boolean> {
  const { data } = useOnboardingStatus();
  return (data as any)?.module_visibility ?? {};
}

/**
 * Returns true if the named module should appear in the sidebar.
 * If the module ID is absent from the map, defaults to true (show by default).
 */
export function useIsModuleVisible(moduleId: string): boolean {
  const visibility = useModuleVisibility();
  return visibility[moduleId] !== false;
}
